import { Component } from '@angular/core';
/**
 *
 *
 * @export
 * @class EvaluacionPsicologicaComponent
 */
@Component({
    selector: 'app-evaluacion-psicologica',
    templateUrl: './evaluacion-psicologica.component.html',
    styleUrls: ['./evaluacion-psicologica.component.scss'],
    standalone: false
})

export class EvaluacionPsicologicaComponent  {

  

}
